import React from "react";
import { string } from "prop-types";
import Square from "../Square";
import Image from "../Image";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { utilityProps, utilityPropTypes } from "../props/utility";
import { spacingProps, spacingPropTypes } from "../props/spacing";
import { colorPropTypes } from "../props/sx";

const LogoCircle = ({
	wrapperClassName = "",
	wrapperBgColor = "black--15",
	wrapperUtility = { ...utilityProps },
	wrapperSpacing = { ...spacingProps },
	contentClassName = "",
	contentUtility = { ...utilityProps },
	contentSpacing = { ...spacingProps },
	imgSrc,
	imgAlt = "",
}) => (
	<Square
		utility={deepMergeProps(
			{ radius: "50p", bgColor: wrapperBgColor, overflow: "hidden" },
			pureProps(wrapperUtility),
		)}
		className={wrapperClassName}
		spacing={wrapperSpacing}
	>
		<Square.Content
			className={contentClassName}
			utility={deepMergeProps(
				{ display: "flex", justify: "center", align: { items: "center" } },
				pureProps(contentUtility),
			)}
			spacing={deepMergeProps(
				{ sm: { p: 4 }, md: { p: 5 }, lg: { p: 8 } },
				pureProps(contentSpacing),
			)}
		>
			<Image src={imgSrc} alt={imgAlt} />
		</Square.Content>
	</Square>
);

LogoCircle.propTypes = {
	wrapperClassName: string,
	wrapperBgColor: colorPropTypes,
	wrapperUtility: utilityPropTypes,
	wrapperSpacing: spacingPropTypes,

	contentClassName: string,
	contentUtility: utilityPropTypes,
	contentSpacing: spacingPropTypes,
	imgSrc: string.isRequired,
	imgAlt: string,
};

export default LogoCircle;
